import { RedirectToService } from './redirect-to/redirect-to.service';

export { RedirectToService };

export default [RedirectToService];
